module.exports = __webpack_public_path__ + "img/05_garnish 1.89fb76ed.png";